import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { StorageService } from 'src/app/share/services/storage.service';
import { CustomEncoder, UrlService } from 'src/app/share/services/url.service';

@Component({
    selector: 'app-email-verify',
    templateUrl: './email-verify.component.html',
    styleUrls: ['./email-verify.component.scss'],
    standalone: false
})
export class EmailVerifyComponent implements OnInit {
  public showSuccess: boolean;
  public showError: boolean;
  public errorMessage: string = '';
  public successMessage: string = '';
  private status: any;
  public inProcess: boolean = false;

  constructor(
    private languageService: LanguageService,
    private _http: HttpClient,
    private _route: ActivatedRoute,
    private _apiService: ApiService,
    private storageService: StorageService,
    private urlService: UrlService
  ) {}

  ngOnInit(): void {
    let ids = this.storageService.getFromLocale('selectedIds');
    if (ids != null && ids != undefined && ids != '') {
      this.urlService.refreshQueryParams({
        i: ids,
      });
    }
    this.verifyEmail();
  }

  private verifyEmail() {
    this.inProcess = true;
    this.showError = this.showSuccess = false;
    const token = this._route.snapshot.queryParams['token'];

    this.confirmEmail(token).subscribe({
      next: (response) => {
        this.status = response;
        if (this.status.status === 0) {
          this.showSuccess = true;
          this.successMessage = this.languageService.translate('completedRegistration');
        } else if (this.status.status === 1) {
          this.showSuccess = true;
          this.successMessage = this.languageService.translate('alreadyCompletedRegistration');
        }
        this.inProcess = false;
      },
      error: (error) => {
        this.showError = true;
        this.errorMessage = this.languageService.translate('notCompletedRegistration');
        this.inProcess = false;
      },
    });
  }

  private confirmEmail(token: string) {
    let params = new HttpParams({ encoder: new CustomEncoder() });
    params = params.append('token', token);
    return this._apiService.post(RouteKeys.Extern.Register.verify_email, { token: token });
  }

  onClickOk() {
    this.urlService.naviToPreserveQueryParams('extern/login');
  }

  onClickMail() {
    this.urlService.naviToPreserveQueryParams('extern/register');
  }
}
